/**
 * Helper DOM scroll per `BuilderPage`. Estratti per ridurre dimensione /
 * complessità del componente principale (max-lines-per-function ≤ 100,
 * complexity ≤ 10).
 *
 * Pure DOM, no React deps. Lato browser (controllati guards per JSDOM).
 */

/**
 * Soglia in pixel sopra cui il `handlePrev` decide "siamo dentro la
 * sezione corrente" vs "siamo all'inizio". 120px ≈ AppTopbar (56px) +
 * StepNav (~80px) - tolleranza. Vedi feedback PR 4 review.
 */
const PREV_SECTION_THRESHOLD_PX = 120;

/**
 * Scrolla alla sezione con `id` dato.
 *
 * **FI-72**: per `'stats'` preferisci l'anchor compact (pool + stat-grid)
 * che skippa l'header lungo — su mobile entra tutto in 1 schermata.
 * Fallback al wrapper `section-stats` se l'anchor compact non esiste.
 */
export function scrollToBuilderSection(id: string): void {
  const targetId =
    id === 'stats' && document.getElementById('section-stats-compact')
      ? 'section-stats-compact'
      : `section-${id}`;
  const el = document.getElementById(targetId);
  el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

/**
 * Logica del `handlePrev`: se l'utente è "dentro la sezione corrente"
 * (cioè ha scrollato sotto l'inizio), scrolla all'inizio della corrente;
 * altrimenti scrolla alla precedente.
 *
 * @param currentSectionId id della sezione corrente
 * @param prevSectionId id della sezione precedente (o undefined se prima)
 */
export function scrollToPrevBuilderSection(
  currentSectionId: string,
  prevSectionId: string | undefined,
): void {
  const currentEl = document.getElementById(`section-${currentSectionId}`);
  if (currentEl && currentEl.getBoundingClientRect().top < PREV_SECTION_THRESHOLD_PX) {
    currentEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return;
  }
  if (prevSectionId) scrollToBuilderSection(prevSectionId);
}
